<template>
  <div class="block block-fx-shadow" :class="{'block-mode-loading': isProcessing}">
    <div class="block-header block-header-default">
      <div class="block-options mr-15">
          <date-picker-drop v-model="range" :filter="filter" @datepick="fetchStats()" />
      </div>
    </div>
    <div class="block-content">
      <line-chart :chart-data="datacollection" :options="chartOptions" :height="100"></line-chart>
    </div>
  </div>
</template>

<script>
import LineChart from '../../../../partials/charts/LineChart.js';
import moment from 'moment';

export default {
  components: {
    LineChart,
  },
  data() {
    return {
      isProcessing: false,
      datacollection: null,
      filter: {
        period_start_date: moment().startOf('month').format('YYYY-MM-DD'),
        period_end_date: moment().endOf('month').format('YYYY-MM-DD'),
      },
      range: [],
      chartOptions: {
        responsive: true,
        maintainAspectRation: true,
        legend: {
          display: true,
          position: 'bottom',
        },
      },
    };
  },
  mounted() {
    this.fetchStats();
  },
  methods: {
    fetchStats() {
      this.isProcessing = true;
      window.axios.get('/users/charts/payments', { params: this.filter })
        .then((res) => {
          this.datacollection = res.data.chartdata;
          this.isProcessing = false;
        });
    },
  },
  watch: {
    range(newValue) {
      if (newValue[0]) {
        this.filter.period_start_date = newValue[0];
      } else {
        this.filter.period_start_date = '';
      }
      if (newValue[1]) {
        this.filter.period_end_date = newValue[1];
      } else {
        this.filter.period_end_date = '';
      }
    },
  },
};
</script>
